(function ($) {
  $(function () {
    $(".nav-widget__dropdown-button").click(function () {
      var $dropdown = $(this).parents(".nav-widget__dropdown");
      $dropdown.toggleClass("open");
      $(".nav-widget__dropdown .has-sub.open").removeClass("open");
      $(".nav-widget__dropdown .sub").hide();
    });

    $(document).on("mouseleave", ".nav-widget__dropdown", function () {
      $(this).removeClass("open");
    });

    $(".nav-widget__dropdown .has-sub").each(function () {
      var $item = $(this);
      var $sub = $item.children(".sub");
      var $button = $(
        '<button class="sub-toggle"><svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="13.45" height="8.8" viewBox="0 0 13.45 8.8"><defs><style>.cls-2{fill:#ef7c00;stroke-width:0px;}</style></defs><polygon class="cls-2" points="0 0 6.73 8.8 13.45 0 0 0"/><polygon class="cls-2" points="0 0 6.73 8.8 13.45 0 0 0"/></svg></button>'
      )
        .appendTo($item)
        .click(function () {
          $item.toggleClass("open");
          $sub.toggle();
          if (!$item.hasClass("open")) {
            $sub.find(".has-sub.open").removeClass("open");
            $sub.find(".sub").hide();
          }
        });
    });
  });
})(jQuery);
